import React from "react";
import "../../styles/settings/settings.css";
import { useTranslation } from "react-i18next";
import { getTranslation } from "../../common/translation";
import { checkMarketAu, checkMarketChile, checkMarketPoland } from "../../utils/helpers";
import { Input } from "@progress/kendo-react-inputs";

const SettingsPanel = ({
  payload,
  payloadHolder,
  marketSettings,
  handleChange,
  handleFocusOut,
  handleSave,
  showError
}) => {
  const { t } = useTranslation();
  const percentSymbol = "%";
  return (
    <div className="settings-panel">
      <h2>{getTranslation("Campaign", t)}</h2>
      {checkMarketAu() ? (
        <>
          <div
            className={`${
              showError && !payload.defaultInterestRate
                ? "error "
                : "input-settings"
            }`}
          >
            <label>{getTranslation("Default Interest rate", t)}</label>
            <Input
              name="defaultInterestRate"
              onChange={handleChange}
              onBlur={handleFocusOut}
              value={payload.defaultInterestRate}
              className="k-input-flat"
            />
            {showError && !payload.defaultInterestRate ? (
              <p>{getTranslation("Please add an interest rate.", t)}</p>
            ) : (
              ""
            )}
          </div>
          <div
            className={`${
              showError && !payload.dealerOriginationFees
                ? "error "
                : "input-settings"
            }`}
          >
            <label>{getTranslation("Dealer Origination Fees", t)}</label>
            <Input
              name="dealerOriginationFees"
              onChange={handleChange}
              onBlur={handleFocusOut}
              value={payload.dealerOriginationFees}
              className="k-input-flat"
            />
            {showError && !payload.dealerOriginationFees ? (
              <p>{getTranslation("Please add dealer origination fee.", t)}</p>
            ) : (
              ""
            )}
          </div>
          <div
            className={`${
              showError && !payload.ppsr ? "error " : "input-settings"
            }`}
          >
            <label>{getTranslation("PPSR (Government fee)", t)}</label>
            <Input
              name="ppsr"
              onChange={handleChange}
              onBlur={handleFocusOut}
              value={payload.ppsr}
              className="k-input-flat"
            />
            {showError && !payload.ppsr ? (
              <p>{getTranslation("Please add PPSR (Government fee).", t)}</p>
            ) : (
              ""
            )}
          </div>
          <div
            className={`${
              showError && !payload.establishmentFee
                ? "error "
                : "input-settings"
            }`}
          >
            <label>{getTranslation("Establishment Fee", t)}</label>
            <Input
              name="establishmentFee"
              onChange={handleChange}
              onBlur={handleFocusOut}
              value={payload.establishmentFee}
              className="k-input-flat"
            />
            {showError && !payload.establishmentFee ? (
              <p>{getTranslation("Please add an establishment fee.", t)}</p>
            ) : (
              ""
            )}
          </div>
          <div
            className={`${
              showError && !payload.accountKeepingFee
                ? "error "
                : "input-settings"
            }`}
          >
            <label>{getTranslation("Account Keeping Fee", t)}</label>
            <Input
              name="accountKeepingFee"
              onChange={handleChange}
              onBlur={handleFocusOut}
              value={payload.accountKeepingFee}
              className="k-input-flat"
            />
            {showError && !payload.accountKeepingFee ? (
              <p>{getTranslation("Please add an account keeping fee.", t)}</p>
            ) : (
              ""
            )}
          </div>
          <div
            className={`${
              showError && !payload.annualKmAllowance
                ? "error "
                : "input-settings"
            }`}
          >
            <label>{getTranslation("Annual km Allowance (GFV only)", t)}</label>
            <Input
              name="annualKmAllowance"
              onChange={handleChange}
              onBlur={handleFocusOut}
              value={payload.annualKmAllowance}
              className="k-input-flat"
            />
            {showError && !payload.annualKmAllowance ? (
              <p>
                {getTranslation(
                  "Please add an annual km Allowance (GFV only).",
                  t
                )}
              </p>
            ) : (
              ""
            )}
          </div>
        </>
      ) : checkMarketChile() ? (
        <>
          <div
            className={`${
              showError && !payload.defaultInterestRate
                ? "error "
                : "input-settings"
            }`}
          >
            <label>{getTranslation("Default Interest rate", t)}</label>
            <Input
              name="defaultInterestRate"
              onChange={handleChange}
              onBlur={handleFocusOut}
              value={payload.defaultInterestRate}
              className="k-input-flat"
            />
            {showError && !payload.defaultInterestRate ? (
              <p>{getTranslation("Please add an interest rate.", t)}</p>
            ) : (
              ""
            )}
          </div>

          <div
            className={`${
              showError && !payload.taxFactor
                ? "error "
                : "input-settings"
            }`}
          >
            <label>{getTranslation("Tax Factor", t)}</label>
            <Input
              name="taxFactor"
              onChange={handleChange}
              onBlur={handleFocusOut}
              value={payload.taxFactor}
              className="k-input-flat"
            />
            {showError && !payload.taxFactor ? (
              <p>{getTranslation("Please add a tax factor", t)}</p>
            ) : (
              ""
            )}
          </div>

          <div
            className={`${
              showError && !payload.expensesVehicleRegistration
                ? "error "
                : "input-settings"
            }`}
          >
            <label>
              {getTranslation(
                "expenses_with_vehicle_registration", t,
                "Expenses + Vehicle registration")}
            </label>
            <Input
              name="expensesVehicleRegistration"
              onChange={handleChange}
              onBlur={handleFocusOut}
              value={payload.expensesVehicleRegistration}
              className="k-input-flat"
            />
            {showError && !payload.expensesVehicleRegistration ? (
              <p>
                {getTranslation(
                  "Please add expenses with vehicle registration",
                  t
                )}
              </p>
            ) : (
              ""
            )}
          </div>

          <div
            className={`${
              showError && !payload.additionalProductAccessories
                ? "error "
                : "input-settings"
            }`}
          >
            <label>
              {getTranslation(
                "additional_product_accessories", t,
                "Additional Product / Accessories")}
            </label>
            <Input
              name="additionalProductAccessories"
              onChange={handleChange}
              onBlur={handleFocusOut}
              value={payload.additionalProductAccessories}
              className="k-input-flat"
            />
            {showError && !payload.additionalProductAccessories ? (
              <p>{getTranslation(
                "please_add_an_additional_product_accessories", t,
                "Please add an additional product / Accessories" )}</p>
            ) : (
              ""
            )}
          </div>

          <div
            className={`${
              showError && !payload.prepaidExpensesPlusInterest
                ? "error "
                : "input-settings"
            }`}
          >
            <label>{getTranslation(
              "prepaid_expenses_and_interest", t,
              "Prepaid Expenses + Interest")}</label>
            <Input
              name="prepaidExpensesPlusInterest"
              onChange={handleChange}
              onBlur={handleFocusOut}
              value={payload.prepaidExpensesPlusInterest}
              className="k-input-flat"
            />
            {showError && !payload.prepaidExpensesPlusInterest ? (
              <p>
                {getTranslation(
                  "please_add_a_prepaid_expenses_and_interest", t,
                  "Please add a prepaid expenses + interest.",)}</p>
            ) : (
              ""
            )}
          </div>
        </>
      )
      : checkMarketPoland () ? (
        <>
        <div
            className={`${showError && !payload.interestRateWibor
                ? "error "
                : "input-settings"}`}
          >
            <label>{getTranslation("wibor", t, "Interest rate Wibor 1M").concat(" (", percentSymbol, ")")}</label>
            <Input
              name="interestRateWibor"
              onChange={handleChange}
              onBlur={handleFocusOut}
              value={payload.interestRateWibor}
              className="k-input-flat" />
            {showError && !payload.interestRateWibor ? (
              <p>{getTranslation("please_add_wibor", t, "Please add interest rate wibor 1M.")}</p>
            ) : (
              ""
            )}
          </div>
          <div
            className={`${showError && !payload.subsidy
                ? "error "
                : "input-settings"}`}
          >
            <label>{getTranslation("Subsidy", t).concat(" (", percentSymbol, ")")}</label>
            <Input
              name="subsidy"
              onChange={handleChange}
              onBlur={handleFocusOut}
              value={payload.subsidy}
              className="k-input-flat" />
            {showError && !payload.subsidy ? (
              <p>{getTranslation("please_add_subsidy", t, "Please add subsidy.")}</p>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        <>
          <div
            className={`${
              showError && !payload.defaultInterestRate
                ? "error "
                : "input-settings"
            }`}
          >
            <label>{getTranslation("Default Interest rate", t)}</label>
            <Input
              name="defaultInterestRate"
              onChange={handleChange}
              onBlur={handleFocusOut}
              value={payload.defaultInterestRate}
              className="k-input-flat"
            />
            {showError && !payload.defaultInterestRate ? (
              <p>{getTranslation("Please add an interest rate.", t)}</p>
            ) : (
              ""
            )}
          </div>
        </>
      )}

      <button
        onClick={handleSave}
        className="primary-btn"
        disabled={
          checkMarketAu()
            ? showError ||
              JSON.stringify(payloadHolder.current) === JSON.stringify(payload)
            : showError ||
              JSON.stringify(marketSettings?.defaultInterestRateFormatted) ===
                payload.defaultInterestRate
        }
      >
        {getTranslation("Save", t)}
      </button>
    </div>
  );
};

export default SettingsPanel;
